var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TodoList',{attrs:{"todos":_vm.allTodos,"is-loading":_vm.isLoadingAllTodoData,"is-last-page":!_vm.hasMoreAllTodos},on:{"loadMoreTodos":_vm.loadMoreTodos}})}
var staticRenderFns = []

export { render, staticRenderFns }